/**
 * Report type enum for saved reports
 */
export enum ReportType {
  CONTENT_PERFORMANCE = 'Content Performance',
  INFLUENCER_ACTIVITY = 'Influencer Activity',
  INDIVIDUAL_INFLUENCER = 'Individual Influencer',
}

/**
 * Saved report interface
 */
export interface SavedReport {
  id: string;
  reportName: string;
  dateCreated: Date;
  lastUpdated: Date;
  type: ReportType;
  creator: string;
  route?: string; // Route to navigate to when clicking report name
}
